import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const services = [
  { path: '/dynamics365', label: 'Microsoft Dynamics 365 Beratung & Implementierung' },
  { path: '/prozessoptimierung', label: 'Prozessoptimierung für Unternehmen' },
  { path: '/individuelle-softwareentwicklung', label: 'Individuelle Softwareentwicklung' },
  { path: '/automatisierung', label: 'Prozessautomatisierung für Unternehmen' },
  { path: '/ki', label: 'Künstliche Intelligenz Lösungen' },
  { path: '/projektmanagement', label: 'Professionelles IT-Projektmanagement' },
  { path: '/desktop-anwendungen', label: 'Desktop-Anwendungen entwickeln lassen' },
  { path: '/app-entwicklung', label: 'App-Entwicklung für iOS & Android' },
  { path: '/devops', label: 'DevOps: CI/CD & Automatisierung' },
];

const RelatedSection = styled.section`
  padding: 3rem 0 5rem;
  background-color: var(--background-color);
`;

const RelatedContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
`;

const RelatedTitle = styled.h2`
  font-size: 1.8rem;
  margin-bottom: 1.5rem;
  text-align: center;
  color: var(--text-color);
`;

const RelatedList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1rem 2rem;
`;

const RelatedItem = styled.li`
  a {
    color: var(--primary-color);
    font-weight: 600;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;

interface RelatedServicesProps {
  /** Pfad der aktuell angezeigten Seite, damit kein Link auf sich selbst gesetzt wird */
  currentPath: string;
}

/**
 * Zeigt aussagekräftige interne Links zu den übrigen Leistungsseiten an.
 * Verbessert die interne Verlinkung und Nutzerführung (SEO-Empfehlung).
 */
const RelatedServices: React.FC<RelatedServicesProps> = ({ currentPath }) => {
  const otherServices = services.filter((service) => service.path !== currentPath);

  return (
    <RelatedSection>
      <RelatedContainer>
        <RelatedTitle>Weitere Leistungen von Byte Forge</RelatedTitle>
        <RelatedList>
          {otherServices.map((service) => (
            <RelatedItem key={service.path}>
              <Link to={service.path}>{service.label}</Link>
            </RelatedItem>
          ))}
        </RelatedList>
      </RelatedContainer>
    </RelatedSection>
  );
};

export default RelatedServices;
